import Minigames from "@/js/Minigames/Minigames";
import { useEffect } from 'react';
import DragDrop from "./DragDrop/DragDrop";
import Qcm from "./Qcm/Qcm";


import Popup from '@/components/shared/Popup/Popup';
import { observer } from "mobx-react-lite";
import { TYPES } from "react-sdk/activities/ActivitiesConverter";
import SoundPlayer from "react-sdk/SoundPlayer";
import Activity from "./Activity/Activity";
import classes from './PopupMinigameSequence.module.css';
import ReordonnerGame from "./ReordonnerPopup/ReordonnerPopup";
import Swipe from "./Swipe/Swipe";
import Qrl from "./Qrl/Qrl";


const PopupMinigameSequence = () => {

  let mg = Minigames.current

  let elementRef = mg?.elementRef


  console.log("mg = ", mg);
  console.log("elementRef = ", elementRef);

  function onFinished() {

    Minigames.stop()
  }

  useEffect(() => {
    // SoundPlayer.playSound("music_MG")
    SoundPlayer.playSound("Popup-activite")

    return () => {
      // SoundPlayer.playSound("music_decors")
    }
  }, []);




  return (
    <Popup className={classes.PopupMinigameSequence} >

      {elementRef !== null &&
      <>
        {mg.type === TYPES.QCM &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={Qcm}
          onFinished={onFinished} />}

        {mg.type === TYPES.QRL &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={Qrl}
          onFinished={onFinished} />}

        {mg.type === TYPES.DRAGDROP &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={DragDrop}
          onFinished={onFinished} />}

        {mg.type === TYPES.REORDONNER &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={ReordonnerGame}
          onFinished={onFinished} />}

        {mg.type === TYPES.SWIPE &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={Swipe}
          onFinished={onFinished} />}


      </>}



    </Popup>
  )
}

export default observer(PopupMinigameSequence)
